import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import { tracked } from '@glimmer/tracking';

export const IMPORT_ITEMS_PER_PAGE = 50;

export default class ImportsIndexController extends Controller {
  @service features!: FeaturesService;

  queryParams = ['page'];
  @tracked page = 1;

  itemsPerPage = IMPORT_ITEMS_PER_PAGE;
}
